import { render, staticRenderFns } from "./px-badge.vue?vue&type=template&id=68ef6464&"
import script from "./px-badge.vue?vue&type=script&lang=ts&"
export * from "./px-badge.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports